// Unit conversion helpers for KAPEI Imposer PRO.
// All internal measurements are in millimeters (mm).
// PDF uses PostScript points (pt): 1 pt = 1/72 inch, 1 inch = 25.4 mm.

export const MM_PER_INCH = 25.4;
export const PT_PER_MM = 72 / MM_PER_INCH; // ≈ 2.83464566929

export const mmToPt = (mm) => mm * PT_PER_MM;
export const ptToMm = (pt) => pt / PT_PER_MM;

// Preview scale: pixels per mm shown on screen. The preview is purely visual;
// real measurements are always in mm and converted to pt at export time.
export const DEFAULT_PX_PER_MM = 2.6;

export const mmToPx = (mm, pxPerMm = DEFAULT_PX_PER_MM) => mm * pxPerMm;
export const pxToMm = (px, pxPerMm = DEFAULT_PX_PER_MM) => px / pxPerMm;

// Compute effective DPI of an image placed in a frame of given mm.
// The maximum of width/height usage is the limiting axis.
export const effectiveDPI = (imgPxW, imgPxH, frameWmm, frameHmm) => {
  if (!imgPxW || !imgPxH || !frameWmm || !frameHmm) return 0;
  const dpiW = (imgPxW / frameWmm) * MM_PER_INCH;
  const dpiH = (imgPxH / frameHmm) * MM_PER_INCH;
  return Math.round(Math.min(dpiW, dpiH));
};

export const round2 = (n) => Math.round(n * 100) / 100;

// Compute the physical mm size of an image at a target DPI (e.g. 300 dpi).
export const pxToMmAtDPI = (px, dpi) => (px / dpi) * MM_PER_INCH;
